import ElectronicPolicy from './ElectronicPolicy';
export default ElectronicPolicy;
